if (!customElements.get('quickshop-drawer')) {
  customElements.define('quickshop-drawer', class extends HTMLElement {
    connectedCallback() {
      const openButtons = document.querySelectorAll('[data-open-quickshop-drawer]');
      const drawer = document.getElementById('QuickShopDrawer');
      const overlay = drawer?.querySelector('[data-drawer-close]');
      const closeBtn = drawer?.querySelector('.global-drawer__close');

      openButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const productHandle = btn.dataset.productHandle;
          if (productHandle) {
            fetch(`/products/${productHandle}?section_id=quickshop-drawer`)
              .then(res => res.text())
              .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const content = tempDiv.querySelector('[data-quick-view-product]');
                const target = drawer.querySelector('.quickshop-drawer__body');
                target.innerHTML = '';
                target.appendChild(content);
                drawer.setAttribute('aria-hidden', 'false');
                drawer.classList.add('is-open');
              });
          }
        });
      });

      [overlay, closeBtn].forEach(el => {
        el?.addEventListener('click', () => {
          drawer.setAttribute('aria-hidden', 'true');
          drawer.classList.remove('is-open');
        });
      });
    }
  });
}
